import { NgModule } from '@angular/core';
import { MarkdownComponent } from './markdown.component';

@NgModule({
  declarations: [MarkdownComponent],
  imports: [],
  exports: [MarkdownComponent]
})
export class MarkdownModule {}
